import React, { useMemo } from 'react';

import { useAppContext } from '../AppContext';
import useFirestoreQuery from '../hooks/useFirestoreQuery';
import LoadingSpinner from './LoadingSpinner';
import NexusFinder from './NexusFinder';
import NexusCard from './NexusCard';
import { useTranslation } from 'react-i18next';

function NexusList({ mode, userNexusId }) {
    const { t } = useTranslation();
    const { db, appId, userId, collection, query, where, orderBy, limit } = useAppContext();

    const nexusQuery = useMemo(() => {
        if (mode === 'mine') {
            return query(collection(db, `artifacts/${appId}/public/data/nexuses`), where('memberIds', 'array-contains', userId));
        } else { // discover
            return query(collection(db, `artifacts/${appId}/public/data/nexuses`), where('privacy', '==', 'public'), orderBy('memberCount', 'desc'), limit(50));
        }
    }, [mode, collection, limit, orderBy, query, where, db, appId, userId]);

    const { data: nexuses, isLoading } = useFirestoreQuery(nexusQuery);

    if (isLoading) return <LoadingSpinner message={t('nexusList.loading')} />;

    return (
        <div className="space-y-4 animate-fadeIn">
            {mode === 'discover' && <NexusFinder />}

            {nexuses.length === 0 ? (
                <p className="text-center text-gray-400 italic py-8">
                    {mode === 'mine' ? t('nexusList.emptyMine') : t('nexusList.emptyDiscover')}
                </p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-4">
                    {nexuses.map(nexus => <NexusCard key={nexus.id} nexus={nexus} userNexusId={userNexusId} />)}
                </div>
            )}
        </div>
    );
}

export default NexusList;